import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge, Button, Card, Grid, ODataTable, QueryOptions, Tabs, Toolbar, ButtonGroup, Panel,
} from 'framework-ui-components';
import PlusIcon from 'framework-ui-components/Components/Icons/PlusIcon';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';
import { PageWrapper } from 'dashboard';
import { creaSuccessione, statiSuccessioni } from 'apis/successioniApi';
import Servizi from 'enums/Servizi';
import ErroreIcon from 'framework-ui-components/Components/Icons/ErroreIcon';
import StatiRicerca from 'enums/StatiRicerca';
import StatoDichiarazione from 'enums/StatoDichiarazione';
import EventoServer from '../../libs/EventoServer';
import RigaDichiarazione from './RigaDichiarazione';
import ModaleCreaSuccessione from './ModaleCreaSuccessione';
import checkServizio from '../../helpers/checkServizio';
import InputRicerca from '../../components/InputRicerca';
import banner from './banner.svg';

const INDICE_ELENCO_DA_MOSTRARE_AVVIO = 0;

function debounce(func, wait, immediate) {
  let timeout;
  return function () {
    const context = this; const
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

class Dichiarazioni extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      dichiarazioni: [],
      stati: {},
      termineRicerca: '',
      nTotali: 0,
      nInLavorazione: 0,
      nComplete: 0,
      nDaInviare: 0,
      nTrasmesse: 0,
      nScartate: 0,
      nInvioNonRiuscito: 0,
      elencoSelezionato: INDICE_ELENCO_DA_MOSTRARE_AVVIO,
      mostraModaleInformativaBloccoTrasmissioni: true,
    };

    this.initializeComponent();
  }

  componentWillMount() {
    this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, '', false);
  }

  componentDidMount() {
    EventoServer.subscribe('DichiarazioneEliminata', this.ricarica);
    EventoServer.subscribe('DichiarazioneStatoModificato', this.dichiarazioneStatoModificato);
    EventoServer.subscribe('DichiarazioneDatiAggiuntiviModificati', this.ricarica);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ufficioSelezionato.CodiceUfficio != nextProps.ufficioSelezionato.CodiceUfficio) {
      this.caricaStati(nextProps.ufficioSelezionato.CodiceUfficio, '', false);
      // this.tabellaDichiarazioni.loadPage();
    }
  }

  componentWillUnmount() {
    EventoServer.unsubscribe('DichiarazioneEliminata');
    EventoServer.unsubscribe('DichiarazioneStatoModificato');
    EventoServer.unsubscribe('DichiarazioneDatiAggiuntiviModificati');
  }

  initializeComponent() {
    this.apriModale = this.apriModale.bind(this);
    this.chiudiModale = this.chiudiModale.bind(this);
    this.crea = this.crea.bind(this);
    this.ricarica = this.ricarica.bind(this);
    this.dichiarazioneStatoModificato = this.dichiarazioneStatoModificato.bind(this);
  }

  caricaStati(studio, termineRicerca, ricerca) {
    statiSuccessioni(studio, termineRicerca)
      .then((resp) => {
        const dati = {};
        for (const i in resp) {
          dati[resp[i].Stato] = resp[i].Totale;
        }

        // Questo stato è "fuori standard" quindi non lo aggiungo nell'enum
        // eventualmente creare un enum custom
        const indiceStatoInvioNonRiuscito = 6;

        const totali = dati[StatiRicerca.TUTTE] || 0;
        const inLavorazione = dati[StatiRicerca.IN_LAVORAZIONE] || 0;
        const complete = dati[StatiRicerca.COMPLETE] || 0;
        const daInviare = dati[StatiRicerca.DA_INVIARE] || 0;
        const trasmesse = dati[StatiRicerca.TRASMESSE] || 0;
        const scartate = dati[StatiRicerca.SCARTATE] || 0;
        const invioNonRiuscito = dati[indiceStatoInvioNonRiuscito] || 0;

        const elencoSelezionato = () => {
          if (scartate != 0) return 4; // per ora insieme alle trasmesse.
          if (invioNonRiuscito != 0) return 3; // per ora insieme alle "da inviare"

          if (termineRicerca && ricerca) {
            if (inLavorazione != 0) return 1;
            if (daInviare != 0) return 3;
            if (complete != 0) return 5;
            if (trasmesse != 0) return 4;
          }

          if (ricerca) {
            return 0;
          }
          return null;
        };

        const aggiornamentiStato = {
          nTotali: totali,
          nInLavorazione: inLavorazione,
          nComplete: complete,
          nDaInviare: daInviare,
          nTrasmesse: trasmesse,
          nScartate: scartate,
          nInvioNonRiuscito: invioNonRiuscito,
        };

        if (elencoSelezionato() != null) {
          aggiornamentiStato.elencoSelezionato = elencoSelezionato();
        }

        this.setState(aggiornamentiStato);
      });
  }

  dichiarazioneStatoModificato = (evt) => {
    // se l'evento riguarda il passaggio allo stato 41, aggiunge una notifica ad-hoc
    if (!!evt && evt.NuovoStato !== evt.VecchioStato) {
      // eventualmente farsi valorizzare le proprietà dell'evento
      // CodiceFiscale e/o Descrizione
      // per migliorare il contenuto dei messaggi
      if (evt.NuovoStato === StatoDichiarazione.DaTrasmettere) {
        const msg = 'Invio telematico in corso';
        SnackbarManager.notifySuccess(msg);
      }
      if (evt.NuovoStato === StatoDichiarazione.TrasmissioneNonRiuscita) {
        const msg = 'Invio telematico non riuscito';
        SnackbarManager.notifyError(msg);
      }
    }
    // per tutti
    this.ricarica();
  };

  ricarica = debounce(() => {
    this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, this.state.termineRicerca.trim(), false);
    this.tabellaDichiarazioni && this.tabellaDichiarazioni.loadPage();
  }, 1000, false);

  apriModale() {
    this.setState({ showModal: true });
  }

  chiudiModale() {
    this.setState({ showModal: false });
  }

  chiudiModaleInfoTrasmissioni = () => {
    this.setState({ mostraModaleInformativaBloccoTrasmissioni: false });
  };

  crea(data) {
    creaSuccessione(
      this.props.ufficioSelezionato.CodiceUfficio,
      data.CodiceFiscale.toUpperCase(),
      data.Nome.toUpperCase(),
      data.Cognome.toUpperCase(),
      data.Tipo,
      data.DataDecesso,
      data.TipoDevoluzione,
      data.ComuneUltimaResidenza,
      data.CodiceComune,
      data.ProvinciaUltimaResidenza,
      data.FlagMortePresunta,
      data.QuadroEb,
      data.QuadroEc,
      data.QuadroEd,
      data.QuadroEg,
      data.QuadroEh,
      data.QuadroEi,
      data.QuadroEl,
      data.QuadroEm,
      data.QuadroEn,
      data.QuadroEo,
      data.QuadroEp,
      data.QuadroEq,
      data.QuadroEr,
      data.QuadroEs,
    )
      .then((resp) => {
        if (resp.Success) {
          window.location.href = `${window.config.urlSuccessioni}/#/Dichiarazione/Frontespizio/${resp.IdDichiarazione.split('/')[1]}`;
        } else {
          SnackbarManager.notifyError(resp.DetectedProblems);
        }
      })
      .fail((err, msg) => this.setState({ contribuente: '', fullContribuente: null, tipoDichiarazione: 0 }));
  }

  onClickCerca = (termineRicerca) => {
    this.setState({ termineRicerca: termineRicerca.trim() }, () => {
      const ricerca = true;
      this.caricaStati(this.props.ufficioSelezionato.CodiceUfficio, termineRicerca.trim(), ricerca);
    });
  };

  setTabSelezionato = (index) => {
    const { elencoSelezionato } = this.state;
    const { ufficioSelezionato } = this.props;

    const fromStorageKey = this.getStorageKey(ufficioSelezionato.CodiceUfficio, elencoSelezionato);
    const toStorageKey = this.getStorageKey(ufficioSelezionato.CodiceUfficio, index);

    const { sortProperty, sortOrder } = JSON.parse(window.sessionStorage.getItem(fromStorageKey) || '{}');
    const toItem = {
      filtri: {},
      pageSize: 10,
      currentPage: 0,
      ...JSON.parse(window.sessionStorage.getItem(toStorageKey) || '{}'),
      sortProperty,
      sortOrder,
    };

    window.sessionStorage.setItem(toStorageKey, JSON.stringify(toItem));

    this.setState({ elencoSelezionato: index });
  };

  getStorageKey(codiceUfficio, tabSelezionato) {
    switch (tabSelezionato) {
      case 0: return `${codiceUfficio}tableTutte_Successioni`;
      case 1: return `${codiceUfficio}tableLavorazione_Successioni`;
      case 2: return `${codiceUfficio}tableComplete_Successioni`;
      case 3: return `${codiceUfficio}tableDaInviare_Successioni`;
      case 4: return `${codiceUfficio}tableTrasmesse_Successioni`;
      default: return '';
    }
  }

  render() {
    const { ufficioSelezionato, accessoNonConsentito, servizioAttivo } = this.props;
    const {
      termineRicerca,
      elencoSelezionato,
      nComplete,
      nTotali,
      nDaInviare,
      nInLavorazione,
      nTrasmesse,
      nScartate,
      nInvioNonRiuscito,
    } = this.state;

    const badgeConteggio = (count) => (count != 0 ? <Badge info>{count}</Badge> : null);
    const badgeConteggioAllarmi = (count) => (count != 0 ? <Badge alarm>{count}</Badge> : null);

    return (
      <PageWrapper helmetTitle="Successioni" pageTitle="Successioni">
        <Grid fluid className="pl-0 pr-0">
          <Grid.Row>
            {accessoNonConsentito
              ? (
                <Grid.Col md="12">
                  <div className="errorBoundary">
                    <div className="errorBoundary__content">
                      <Badge alarm><ErroreIcon /></Badge>
                      <h2>Il servizio Successioni non è attivo</h2>
                    </div>
                  </div>
                </Grid.Col>
              )
              : (
                <Grid.Col md="12">
                  <Card
                    title="Lista dichiarazioni"
                    className="table--filters-15"
                    multipleActions={
                      this.props.servizioAttivo == true
                                        && <ButtonGroup><Button primary floating onClick={this.apriModale}><PlusIcon /></Button></ButtonGroup>
                    }
                  >
                    <Grid.Row>
                      <Grid.Col md="5">
                        <InputRicerca onClickCerca={this.onClickCerca} />
                      </Grid.Col>
                    </Grid.Row>
                    {!servizioAttivo && !accessoNonConsentito && <Panel error>Il servizio non è attivo. L'accesso è permesso solo in consultazione</Panel>}
                    <Tabs initialIndex={INDICE_ELENCO_DA_MOSTRARE_AVVIO} index={elencoSelezionato} onSelect={this.setTabSelezionato}>
                      <Tabs.Tab title={<span>Tutte {badgeConteggio(nTotali)}</span>}>
                        <ODataTable
                          ref={(r) => this.tabellaDichiarazioni = r}
                          hover
                          clickable
                          url={`/Successioni/CercaSuccessioni?tipoRicerca=${StatiRicerca.TUTTE}&studio=${ufficioSelezionato.CodiceUfficio}&termineRicerca=${termineRicerca}`}
                          row={RigaDichiarazione}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                        >
                          <ODataTable.Column propertyName="CodiceFiscale">Codice fiscale</ODataTable.Column>
                          <ODataTable.Column propertyName="Cognome">Cognome</ODataTable.Column>
                          <ODataTable.Column propertyName="Nome">Nome</ODataTable.Column>
                          <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                          <ODataTable.Column propertyName="Tipo">Tipo</ODataTable.Column>
                          <ODataTable.Column>Tipo devoluzione</ODataTable.Column>
                          <ODataTable.Column className="text--center">FiscOnline</ODataTable.Column>
                          <ODataTable.Column>Data scadenza</ODataTable.Column>
                          <ODataTable.Column className="text--center">Pagamento</ODataTable.Column>
                          <ODataTable.Column className="text--center">Ricevuta Definitiva</ODataTable.Column>
                          <ODataTable.Column className="text--center">Voltura</ODataTable.Column>
                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>In lavorazione {badgeConteggio(nInLavorazione)}</span>}>
                        <ODataTable
                          ref={(r) => this.tabellaDichiarazioni = r}
                          hover
                          clickable
                          url={`/Successioni/CercaSuccessioni?tipoRicerca=${StatiRicerca.IN_LAVORAZIONE}&studio=${ufficioSelezionato.CodiceUfficio}&termineRicerca=${termineRicerca}`}
                          row={RigaDichiarazione}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                        >
                          <ODataTable.Column propertyName="CodiceFiscale">Codice fiscale</ODataTable.Column>
                          <ODataTable.Column propertyName="Cognome">Cognome</ODataTable.Column>
                          <ODataTable.Column propertyName="Nome">Nome</ODataTable.Column>
                          <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                          <ODataTable.Column propertyName="Tipo">Tipo</ODataTable.Column>
                          <ODataTable.Column>Tipo devoluzione</ODataTable.Column>
                          <ODataTable.Column className="text--center">FiscOnline</ODataTable.Column>
                          <ODataTable.Column>Data scadenza</ODataTable.Column>
                          <ODataTable.Column />
                          <ODataTable.Column />
                          <ODataTable.Column />
                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Complete {badgeConteggio(nComplete)}</span>}>
                        <ODataTable
                          ref={(r) => this.tabellaDichiarazioni = r}
                          hover
                          clickable
                          url={`/Successioni/CercaSuccessioni?tipoRicerca=${StatiRicerca.COMPLETE}&studio=${ufficioSelezionato.CodiceUfficio}&termineRicerca=${termineRicerca}`}
                          row={RigaDichiarazione}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                        >
                          <ODataTable.Column propertyName="CodiceFiscale">Codice fiscale</ODataTable.Column>
                          <ODataTable.Column propertyName="Cognome">Cognome</ODataTable.Column>
                          <ODataTable.Column propertyName="Nome">Nome</ODataTable.Column>
                          <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                          <ODataTable.Column propertyName="Tipo">Tipo</ODataTable.Column>
                          <ODataTable.Column>Tipo devoluzione</ODataTable.Column>
                          <ODataTable.Column className="text--center">FiscOnline</ODataTable.Column>
                          <ODataTable.Column>Data scadenza</ODataTable.Column>
                          <ODataTable.Column />
                          <ODataTable.Column />
                          <ODataTable.Column />
                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Da inviare {badgeConteggio(nDaInviare)} {badgeConteggioAllarmi(nInvioNonRiuscito)}</span>}>
                        <ODataTable
                          ref={(r) => this.tabellaDichiarazioni = r}
                          hover
                          clickable
                          url={`/Successioni/CercaSuccessioni?tipoRicerca=${StatiRicerca.DA_INVIARE}&studio=${ufficioSelezionato.CodiceUfficio}&termineRicerca=${termineRicerca}`}
                          row={RigaDichiarazione}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                        >
                          <ODataTable.Column propertyName="CodiceFiscale">Codice fiscale</ODataTable.Column>
                          <ODataTable.Column propertyName="Cognome">Cognome</ODataTable.Column>
                          <ODataTable.Column propertyName="Nome">Nome</ODataTable.Column>
                          <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                          <ODataTable.Column propertyName="Tipo">Tipo</ODataTable.Column>
                          <ODataTable.Column>Tipo devoluzione</ODataTable.Column>
                          <ODataTable.Column className="text--center">FiscOnline</ODataTable.Column>
                          <ODataTable.Column>Data scadenza</ODataTable.Column>
                          <ODataTable.Column />
                          <ODataTable.Column />
                          <ODataTable.Column />
                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>

                      <Tabs.Tab title={<span>Trasmesse {badgeConteggio(nTrasmesse)} {badgeConteggioAllarmi(nScartate)}</span>}>
                        <ODataTable
                          ref={(r) => this.tabellaDichiarazioni = r}
                          hover
                          clickable
                          url={`/Successioni/CercaSuccessioni?tipoRicerca=${StatiRicerca.TRASMESSE}&studio=${ufficioSelezionato.CodiceUfficio}&termineRicerca=${termineRicerca}`}
                          row={RigaDichiarazione}
                          pageSize={10}
                          availablePageSizes={[10, 20, 50]}
                        >
                          <ODataTable.Column propertyName="CodiceFiscale">Codice fiscale</ODataTable.Column>
                          <ODataTable.Column propertyName="Cognome">Cognome</ODataTable.Column>
                          <ODataTable.Column propertyName="Nome">Nome</ODataTable.Column>
                          <ODataTable.Column propertyName="Stato">Stato</ODataTable.Column>
                          <ODataTable.Column propertyName="Tipo">Tipo</ODataTable.Column>
                          <ODataTable.Column>Tipo devoluzione</ODataTable.Column>
                          <ODataTable.Column className="text--center">FiscOnline</ODataTable.Column>
                          <ODataTable.Column>Data scadenza</ODataTable.Column>
                          <ODataTable.Column className="text--center">Pagamento</ODataTable.Column>
                          <ODataTable.Column className="text--center">Ricevuta Definitiva</ODataTable.Column>
                          <ODataTable.Column className="text--center">Voltura</ODataTable.Column>
                          <ODataTable.Column className="w-40" />
                        </ODataTable>
                      </Tabs.Tab>
                    </Tabs>
                  </Card>
                </Grid.Col>
              )}
          </Grid.Row>

          <ModaleCreaSuccessione
            showModal={this.state.showModal}
            onCrea={this.crea}
            onClose={this.chiudiModale}
          />
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStoreToProps = (store) => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
});

Dichiarazioni.propTypes = {
  ufficioSelezionato: PropTypes.object,
  accessoNonConsentito: PropTypes.bool,
  servizioAttivo: PropTypes.bool,
};

export default checkServizio(Servizi.SUC)(connect(mapStoreToProps)(Dichiarazioni));
